import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Router } from '@angular/router';

export function events_needing_instructors(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);

  return {
    name: 'Events der mangler instruktører',
    description: 'Kun fremtidige events; filtrer efter om de har mindst én instruktør eller ej',
    execute: (params?: LoadDataParams): Observable<any> => {
      const requestParams: LoadDataParams = {
        ...(params || {} as any),
        dataSourceKey: 'events_needing_instructors',
        filters: params?.filters || []
      };
      return componentDataSourceService['loadDataWithStandardFiltersGET'](
        'events_needing_instructors',
        '/events/needing-instructors',
        requestParams
      ).pipe(
        catchError(error => {
          console.error('Error fetching events needing instructors:', error);
          return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
        }),
        map(result => {
          const items = result?.items ?? result?.data ?? [];
          const meta = result?.meta ?? {};
          return {
            items,
            totalCount: result?.totalCount ?? meta?.totalItems ?? items.length,
            pageSize: result?.pageSize ?? meta?.pageSize ?? 10,
            pageIndex: result?.pageIndex ?? (meta?.page != null ? meta.page - 1 : 0),
            filters: result?.filters
          };
        })
      );
    },
    settings: {
      pageSize: 10,
      pageSizeOptions: [10, 25, 50, 100],
      columns: [
        { key: 'start_date', header: 'Start', type: 'date', sortable: true },
        { key: 'end_date', header: 'Slut', type: 'date', sortable: true },
        { key: 'event_type_display', header: 'Type', type: 'text', sortable: true },
        { key: 'event_name', header: 'Navn', type: 'text', sortable: true, wrap: true },
        { key: 'location', header: 'Lokation', type: 'text', sortable: true, wrap: true },
        { key: 'instructor_count', header: 'Antal instruktører', type: 'text', sortable: true, alignment: 'right' as const },
        { key: 'in_invitation_display', header: 'I invitation', type: 'text', sortable: false },
        {
          key: 'view_event',
          header: '',
          type: 'button',
          buttonText: 'Vis event',
          buttonColor: 'primary',
          alignment: 'right' as const,
          variant: 'stroked',
          action: (row: any) => {
            const url = router.serializeUrl(router.createUrlTree(['/event', row.guid]));
            window.open(url, '_blank');
          }
        }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: true,
      defaultSortColumn: 'start_date',
      defaultSortDirection: 'asc',
      multiSelect: true,
      filters: [
        { column: 'excludeAlreadyInInvitation', value: true, operator: 'equals' as const, label: 'Skjul i invitation', options: [] }
      ],
      tableOptions: [
        {
          id: 'excludeAlreadyInInvitation',
          label: 'Skjul events der allerede er i en invitation',
          type: 'toggle',
          default: true,
          onChange: () => {}
        },
        {
          id: 'includeWithInstructors',
          label: 'Vis også events med mindst 1 instruktør',
          type: 'toggle',
          default: false,
          onChange: () => {}
        }
      ]
    }
  };
}
